<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header class="missing-subscription-error-modal__header">{{ title }}</h1>

  <div class="missing-subscription-error-modal">
    <p class="missing-subscription-error-modal__body">{{ text }}</p>

    <button class="btn_primary btn_lg" (click)="onChooseNumber()">{{ buttonText }}</button>
  </div>
</app-base-modal>
